export const selectSearch = {
    created: (el, binding) => {
        const search = binding.value
        const text = el.innerText
        el.innerHTML = getSelectedHtml(search, text)
    },

    updated: (el, binding) => {
        const search = binding.value
        const text = el.innerText
        el.innerHTML = getSelectedHtml(search, text)
    },
}

function getSelectedHtml(search: string, text: string): string {
    return search && text.match(new RegExp(`^${search}`, 'gi')) ? `<span class="text-primary">${text.substring(0, search.length)}</span>${text.substring(search.length)}` : text
}
